export default "/images/gotovo.png?6bdd79ede629f1b10dbf0bdcd0d0070d";